export default "__VITE_ASSET__DXZr_mCo__"